import $ from 'jquery';

const AVAILABLE_CMS = ['litepms', 'travel_line', 'bnovo', 'bronirui_online', 'agast'];

const TOUR_OPERATOR_PRIORITY = {
  alean: 1,
  ostrovok: 2,
  multitour: 3,
  delfin: 4,
  bg_operator: 5,
  rsttur: 6,
};

export function mergeApartments(firstData, secondData, updateApartmentsCount, totalGuestCount) {
  const $firstTemp = $('<div>').html(firstData['full']);
  const $secondTemp = $('<div>').html(secondData['full']);

  let $apartmentsList;

  if ($firstTemp.find('.search-none').length > 0) {
    $apartmentsList = $secondTemp.find('ul.rooms-list:not(.rooms-list_complex)');
  } else if ($secondTemp.find('.search-none').length > 0) {
    $apartmentsList = $firstTemp.find('ul.rooms-list:not(.rooms-list_complex)');
  } else {
    const allApartments = collectAllApartments(
      $firstTemp.find('.rooms-list-item'),
      $secondTemp.find('.rooms-list-item')
    );

    const { apartmentsToShow } = chooseApartments(allApartments, totalGuestCount);

    $apartmentsList = renderApartmentsList($firstTemp, apartmentsToShow, allApartments, totalGuestCount);
  }

  updateApartmentsCount($apartmentsList);

  if ($firstTemp.find('.search-none').length > 0) {
    secondData.full = $secondTemp.html();
  } else {
    secondData.full = $firstTemp.html();
  }
}

function extractApartments($apartments, apartmentIds, allApartments) {
  $apartments.each(function () {
    const $el = $(this);
    const apartmentId = $el.data('apartment-id');
    if (!apartmentId || apartmentIds.has(apartmentId)) return;

    apartmentIds.add(apartmentId);

    let pricesRaw = {};
    try {
      pricesRaw = JSON.parse($el.attr('data-prices-by-seats') || '{}');
    } catch (e) {
      pricesRaw = {};
    }
    const pricesBySeats = {};
    Object.entries(pricesRaw).forEach(([k, v]) => {
      const num = Number(v);
      if (isFinite(num)) pricesBySeats[parseInt(k, 10)] = num;
    });

    const sourceRaw = $el.data('source');
    const source = typeof sourceRaw === 'string' ? sourceRaw : sourceRaw === undefined ? '' : String(sourceRaw);
    const commission = parseFloat($el.data('commission')) || 0;
    const instant = $el.data('instant') === true || $el.data('instant') === 'true';

    allApartments.push({
      el: $el,
      id: String(apartmentId),
      source: source || '',
      commission,
      instant,
      pricesBySeats,
      isAdditional: false,
    });
  });
}

function collectAllApartments($firstApartments, $secondApartments) {
  const allApartments = [];
  const apartmentIds = new Set();

  extractApartments($firstApartments, apartmentIds, allApartments);
  extractApartments($secondApartments, apartmentIds, allApartments);

  return allApartments;
}

function chooseApartments(allApartments, totalGuestCount) {
  const integrationGroups = {};
  const nonIntegratedApartments = [];

  allApartments.forEach((apartment) => {
    const isNonIntegrated = AVAILABLE_CMS.includes(apartment.source) || apartment.source === 'mt';
    if (isNonIntegrated) {
      nonIntegratedApartments.push(apartment);
    } else {
      if (!integrationGroups[apartment.source]) integrationGroups[apartment.source] = [];
      integrationGroups[apartment.source].push(apartment);
    }
  });

  const exactMatchApartments = filterExactMatch(nonIntegratedApartments, totalGuestCount);
  const exactMatchIntegrationGroups = filterExactMatchGroups(integrationGroups, totalGuestCount);

  let apartmentsToShow = [];
  let additionalApartments = [];

  if (exactMatchApartments.length > 0) {
    apartmentsToShow = exactMatchApartments;

    const minPriceForExactSeats = findMinPriceForExactSeats(exactMatchApartments, totalGuestCount);
    const bestIntegration = findIntegrationWithMinPriceForExactSeats(exactMatchIntegrationGroups, totalGuestCount);

    if (bestIntegration && minPriceForExactSeats !== null && bestIntegration.price < minPriceForExactSeats) {
      apartmentsToShow = apartmentsToShow.concat(exactMatchIntegrationGroups[bestIntegration.service] || []);
    }

    const mainIds = new Set(apartmentsToShow.map((a) => a.id));
    additionalApartments = allApartments.filter((a) => !mainIds.has(a.id));
  } else if (Object.keys(exactMatchIntegrationGroups).length > 0) {
    const selectedIntegration = findIntegrationWithMinPriceForExactSeats(exactMatchIntegrationGroups, totalGuestCount);
    apartmentsToShow = selectedIntegration ? exactMatchIntegrationGroups[selectedIntegration.service] : [];
    const mainIds = new Set(apartmentsToShow.map((a) => a.id));
    additionalApartments = allApartments.filter((a) => !mainIds.has(a.id));
  } else {
    ({ apartmentsToShow, additionalApartments } = processAndSelect(
      allApartments,
      integrationGroups,
      nonIntegratedApartments,
      integrationGroups,
      totalGuestCount
    ));

    if (apartmentsToShow.length === 0) {
      apartmentsToShow = allApartments.slice();
      additionalApartments = [];
    }
  }

  return { apartmentsToShow, allApartments, additionalApartments };
}

function compareApartments(a, b, totalGuestCount) {
  // 1. Вместимость
  const seatsA = getAvailableSeats(a);
  const seatsB = getAvailableSeats(b);

  if (seatsA.length > 0 && seatsB.length > 0) {
    const aBestSeats = findBestSeats(seatsA, totalGuestCount);
    const bBestSeats = findBestSeats(seatsB, totalGuestCount);

    const aSeatsDiff = aBestSeats - totalGuestCount;
    const bSeatsDiff = bBestSeats - totalGuestCount;

    if (aSeatsDiff * bSeatsDiff >= 0) {
      const aAbsDiff = Math.abs(aSeatsDiff);
      const bAbsDiff = Math.abs(bSeatsDiff);

      if (aAbsDiff !== bAbsDiff) {
        return aAbsDiff - bAbsDiff;
      }

      const aPrice = a.pricesBySeats[aBestSeats] || Infinity;
      const bPrice = b.pricesBySeats[bBestSeats] || Infinity;

      if (aPrice !== bPrice && isFinite(aPrice) && isFinite(bPrice)) {
        return aPrice - bPrice;
      }
    } else {
      if (aSeatsDiff > 0 && bSeatsDiff < 0) return -1;
      if (aSeatsDiff < 0 && bSeatsDiff > 0) return 1;
    }
  }

  // 2. Моментальное бронирование
  if (a.instant !== b.instant) return (b.instant === true ? 1 : 0) - (a.instant === true ? 1 : 0);

  // 3. Минимальная цена
  const numsA = Object.values(a.pricesBySeats || {})
    .map(Number)
    .filter(Number.isFinite);
  const numsB = Object.values(b.pricesBySeats || {})
    .map(Number)
    .filter(Number.isFinite);
  const minA = numsA.length ? Math.min(...numsA) : Infinity;
  const minB = numsB.length ? Math.min(...numsB) : Infinity;

  if (minA !== minB) return minA - minB;

  // 4. Комиссия
  return (b.commission || 0) - (a.commission || 0);
}

function findBestSeats(availableSeats, targetSeats) {
  if (availableSeats.includes(targetSeats)) {
    return targetSeats;
  }

  const bestSeats = availableSeats.filter((seats) => seats > targetSeats);
  if (bestSeats.length > 0) {
    return Math.min(...bestSeats);
  }

  return Math.max(...availableSeats);
}

function getAvailableSeats(apartment) {
  return Object.keys(apartment.pricesBySeats || {})
    .map(Number)
    .filter(Number.isFinite)
    .filter((seats) => apartment.pricesBySeats[seats] > 0)
    .sort((a, b) => a - b);
}

function buildGroupedOrdered(apartments, totalGuestCount) {
  const map = new Map();

  const apartmentsWithPrice = apartments.filter((a) => Object.keys(a.pricesBySeats || {}).length > 0);
  const apartmentsWithoutPrice = apartments.filter((a) => Object.keys(a.pricesBySeats || {}).length === 0);

  apartmentsWithPrice.forEach((a) => {
    if (!map.has(a.source)) map.set(a.source, []);
    map.get(a.source).push(a);
  });

  map.forEach((arr) => arr.sort((a, b) => compareApartments(a, b, totalGuestCount)));

  if (apartmentsWithoutPrice.length > 0) {
    map.set('', apartmentsWithoutPrice);
  }

  return map;
}

function renderApartmentsList($firstTemp, apartmentsToShow, allApartments, totalGuestCount) {
  const mainIds = new Set(apartmentsToShow.map((a) => a.id));
  allApartments.forEach((apartment) => {
    const isMain = mainIds.has(apartment.id);
    apartment.isAdditional = !isMain;
    apartment.el.attr('data-additional', String(!isMain));
    if (isMain) {
      apartment.el.removeClass('hidden');
    } else {
      apartment.el.addClass('hidden');
    }
  });

  const mainOrderedGroups = buildGroupedOrdered(apartmentsToShow, totalGuestCount);
  const additionalOrderedGroups = buildGroupedOrdered(
    allApartments.filter((a) => !mainIds.has(a.id)),
    totalGuestCount
  );

  const $apartmentsList = $firstTemp.find('ul.rooms-list:not(.rooms-list_complex)');
  $apartmentsList.children().not('.rooms-list-title').remove();

  mainOrderedGroups.forEach((group) => {
    group.forEach((apartment) => {
      $apartmentsList.append(apartment.el);
    });
  });

  additionalOrderedGroups.forEach((group) => {
    group.forEach((apartment) => {
      $apartmentsList.append(apartment.el);
    });
  });

  $firstTemp.find('#load-more-apartments').remove();
  if ([...additionalOrderedGroups.values()].some((g) => g.length > 0)) {
    const classNames = window.isMobileDevice ? 'border-rounded typography-normal button-fullwidth' : 'btn btn_border';
    const $loadMoreBtn = $(
      `<div id="load-more-apartments" class="${classNames} margin-top-20" style="text-align: center">Загрузить еще</div>`
    );
    $apartmentsList.after($loadMoreBtn);
  }

  return $apartmentsList;
}

function filterExactMatch(apartments, totalGuestCount) {
  const hasAnyExact = apartments.some((apartment) => {
    return Object.entries(apartment.pricesBySeats).some(([seatsStr, price]) => {
      const seats = parseInt(seatsStr, 10);
      return seats === totalGuestCount && Number.isFinite(price) && price > 0 && apartment.instant;
    });
  });

  if (!hasAnyExact) return [];

  return apartments.filter((apartment) => {
    return Object.values(apartment.pricesBySeats).some(
      (price) => Number.isFinite(price) && price > 0 && apartment.instant
    );
  });
}

function filterExactMatchGroups(integrationGroups, totalGuestCount) {
  const result = {};
  Object.entries(integrationGroups).forEach(([service, apartments]) => {
    const filtered = filterExactMatch(apartments, totalGuestCount);
    if (filtered.length > 0) {
      result[service] = filtered;
    }
  });
  return result;
}

function processAndSelect(apartments, integrationGroups, nonIntegratedApartments, allGroups, totalGuestCount) {
  const minPriceForExactSeats = findMinPriceForExactSeats(nonIntegratedApartments, totalGuestCount);

  let apartmentsToShow = [...nonIntegratedApartments];
  let additionalApartments = [];

  let selectedIntegration = findIntegrationWithMinPriceForExactSeats(integrationGroups, totalGuestCount);

  if (selectedIntegration) {
    if (minPriceForExactSeats === null || selectedIntegration.price < minPriceForExactSeats) {
      apartmentsToShow = apartmentsToShow.concat(allGroups[selectedIntegration.service] || []);
    }
  }

  const mainIds = new Set(apartmentsToShow.map((a) => a.id));
  additionalApartments = apartments.filter((a) => !mainIds.has(a.id));

  return { apartmentsToShow, additionalApartments };
}

function findMinPriceForExactSeats(apartments, seats) {
  let minPrice = null;

  apartments.forEach((apartment) => {
    const price = apartment.pricesBySeats[seats];
    if (Number.isFinite(price) && price > 0) {
      if (minPrice === null || price < minPrice) {
        minPrice = price;
      }
    }
  });

  return minPrice;
}

function findIntegrationWithMinPriceForExactSeats(integrationGroups, targetSeats) {
  let selected = null;

  Object.entries(integrationGroups).forEach(([service, group]) => {
    let bestInGroup = null;

    group.forEach((apartment) => {
      const price = apartment.pricesBySeats[targetSeats];
      if (!Number.isFinite(price) || price <= 0) return;

      const candidate = {
        service,
        price: Number(price),
        instant: apartment.instant,
      };

      if (!bestInGroup) {
        bestInGroup = candidate;
      } else {
        if (candidate.instant !== bestInGroup.instant) {
          if (candidate.instant) bestInGroup = candidate;
        } else if (candidate.price < bestInGroup.price) {
          bestInGroup = candidate;
        }
      }
    });

    if (!bestInGroup) return;

    if (!selected) {
      selected = bestInGroup;
    } else {
      if (bestInGroup.instant !== selected.instant) {
        if (bestInGroup.instant) selected = bestInGroup;
      } else if (bestInGroup.price < selected.price) {
        selected = bestInGroup;
      } else if (bestInGroup.price === selected.price) {
        const prioA = TOUR_OPERATOR_PRIORITY[bestInGroup.service] || 999;
        const prioB = TOUR_OPERATOR_PRIORITY[selected.service] || 999;
        if (prioA < prioB) {
          selected = bestInGroup;
        }
      }
    }
  });

  return selected;
}
